import { Flex, Form, Switch } from "antd"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import { Text } from "ui/Typography"

export const FullPayment = () => {
  const [t] = useTranslation()
  return (
    <Flex vertical gap={spacings.S}>
      <Text variant="sub" size="md">
        {t("global.payment")}
      </Text>
      <Flex align="center" gap={spacings.XS}>
        <Form.Item name="full_payment_required" className="mb-0">
          <Switch size="small" />
        </Form.Item>
        <Text variant="body" size="md">
          {t("experiences.scheduling.sections.length_and_rates.full_payment")}
        </Text>
      </Flex>
    </Flex>
  )
}
